// src/modules/estimates/aiEstimateService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const getAuthToken = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('No token found. Please login again.');
  }
  return token;
};

const getHeaders = () => {
  const token = getAuthToken();
  if (!token) return {};
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const generateIntroduction = async (items, totalPrice, customInstructions) => {
  const response = await axios.post(`${API_URL}/ai-estimate/generate-introduction`, { items, totalPrice, customInstructions }, getHeaders());
  return response.data;
};

export const generateFootnotes = async (items, totalPrice, customInstructions) => {
  const response = await axios.post(`${API_URL}/ai-estimate/generate-footnotes`, { items, totalPrice, customInstructions }, getHeaders());
  return response.data;
};

export const getEstimatePrompts = async () => {
  const response = await axios.get(`${API_URL}/ai-estimate/prompts`, getHeaders());
  return response.data;
};

export const updateEstimatePrompts = async (prompts) => {
  const response = await axios.put(`${API_URL}/ai-estimate/prompts`, prompts, getHeaders());
  return response.data;
};
